import { render } from "./FooterWeb.vue?vue&type=template&id=79d91f58&scoped=true"
import script from "./FooterWeb.vue?vue&type=script&lang=js"
export * from "./FooterWeb.vue?vue&type=script&lang=js"

import "./FooterWeb.vue?vue&type=style&index=0&id=79d91f58&scoped=true&lang=css"

import exportComponent from "/Users/elvispardo/Desktop/PROYECTOS/pypa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d91f58"]])

export default __exports__